import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FreelancerCard from "./FreelancerCard";
import { useLanguage } from "../context/LanguageContext";
import freelancersData from "../data/freelancers.js";

const FreelancersGrid = ({ showViewAll = true, limit = null }) => {
  const { t } = useLanguage();

  const safeFreelancers = Array.isArray(freelancersData) ? freelancersData : [];
  const safeLimit = typeof limit === "number" ? limit : null;
  const items = safeLimit ? safeFreelancers.slice(0, safeLimit) : safeFreelancers;

  console.log("freelancersData:", freelancersData);
  console.log("is array:", Array.isArray(freelancersData));
  console.log("length:", freelancersData?.length);
  console.log("items:", items);
  console.log("items length:", items?.length);

  return (
    <section
      id="freelancers"
      className="py-24 lg:py-32 bg-[#F3F4F1] border-y border-[rgba(117,148,122,0.12)]"
      data-testid="freelancers-grid-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
              {t?.freelancers?.label || "Freelancers"}
            </span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] text-[#202C21] font-semibold">
              {t?.freelancers?.title || "Freelancers in Ericeira"}
            </h2>
            <p className="mt-4 text-base text-[#5C6B5D] leading-relaxed">
              {t?.freelancers?.subtitle || "Explore local freelancers and connect directly."}
            </p>
          </div>

          {showViewAll && (
            <Link
              to="/freelancers"
              className="inline-flex items-center gap-2 text-[#202C21] hover:text-[#5F7C63] font-medium transition-colors self-start md:self-end"
              data-testid="freelancers-view-all"
            >
              {t?.freelancers?.view_all || "View all"}
              <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
            </Link>
          )}
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {items.map((f, i) => (
            <FreelancerCard key={f.slug || i} freelancer={f} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FreelancersGrid;